import i18n from '../i18n';

/** Кодове на ClientValidationException от client-service. */
export const ClientValidationCode = {
    InvalidVatFormat: 'client_invalid_vat_format',
    InvalidEik: 'client_invalid_eik',
    InvalidEgn: 'client_invalid_egn',
    CompanyDeleted: 'client_company_deleted',
    PersonEikIsCompany: 'client_person_eik_is_company',
    FieldsCannotBeCleared: 'client_fields_cannot_be_cleared',
} as const;

export type ClientValidationCodeKey = (typeof ClientValidationCode)[keyof typeof ClientValidationCode];

export interface ClientValidationError {
    type: 'ERROR';
    errorCode: number;
    error: ClientValidationCodeKey;
    fields: string[];
}

/** Кодовете с едно фиксирано съобщение. */
const MESSAGE_KEYS: Partial<Record<ClientValidationCodeKey, string>> = {
    [ClientValidationCode.InvalidVatFormat]: 'clientValidation.invalidVatFormat',
    [ClientValidationCode.InvalidEik]: 'clientValidation.invalidEik',
    [ClientValidationCode.InvalidEgn]: 'clientValidation.invalidEgn',
    [ClientValidationCode.CompanyDeleted]: 'clientValidation.companyDeleted',
    [ClientValidationCode.PersonEikIsCompany]: 'clientValidation.personEikIsCompany',
};

const CLEARABLE_FIELDS = ['owner', 'vat', 'companyAddress', 'phone', 'contact', 'city'];

export function translateClientValidationError(value: unknown): string | undefined {
    const error = value as Partial<ClientValidationError> | undefined;
    if (error?.type !== 'ERROR' || !error.error) return undefined;
    const messageKey = MESSAGE_KEYS[error.error];
    if (messageKey) return String(i18n.t(messageKey));
    if (error.error !== ClientValidationCode.FieldsCannotBeCleared) return undefined;
    const fields = Array.isArray(error.fields) ? error.fields.filter(field => CLEARABLE_FIELDS.includes(field)) : [];
    return String(i18n.t('clientValidation.cannotClearFields', {
        fields: fields.map(field => i18n.t(`clientValidation.fields.${field}`)).join(', '),
        vatHint: fields.includes('vat') ? i18n.t('clientValidation.clearVatHint') : '',
    }));
}
